import "./index.css";

const SPONSORSHIP_URL = "/sponsorships-and-sponsored-content/";

const DISCLAIMER_CONTENT = {
  articles: {
    text: "This article contains sponsored content. Some of the products featured are part of paid partnerships. ",
    linkText: "This page explains how our process works.",
  },
  brands: {
    text: "This page contains sponsored content. The brands and products featured are part of paid partnerships. ",
    linkText: "Learn more about our process.",
  },
};

const Disclaimer = ({ type }) => {
  const content = DISCLAIMER_CONTENT[type];

  if (!content) {
    return null;
  }

  return (
    <p className="Disclaimer">
      {content.text}
      <a href={SPONSORSHIP_URL}>{content.linkText}</a>
    </p>
  );
};

export default Disclaimer;